import React, { useState } from 'react';

import ContentPreviewModal from '@/components/common-components/ContentPreviewModal/ContentPreviewModal';
import PaginationComponent from '@/components/Dashboard/components/PaginationComponent';

import GeneralTable from '../../../../../common-components/GeneralTable/GeneralTable';
import GeneralTableHead from '../../../../../common-components/GeneralTable/GeneralTableHead';
import { SOCIAL_LISTEING_TABLE_HEADERS } from '../../../constants';
import GetSocialListeningModal from '../../modals/GetSocialListeningModal';
import { useCampaignDetail } from '../CampaignDetailProvider';
import NoContent from '../NoContent';
import NoPostAvailable from '../NoPostAvailable';
import ContentListTableItem from './ContentListTableItem';

const ContentListSection = ({ tableHeadStyle = {} }) => {
  const { content, isTrackingInProgress, isNextContent, contentCurrentPage, onPageChange } = useCampaignDetail();

  const [getAddOnModalOpen, setGetAddOnModalOpen] = useState(0);

  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  const openPreview = (post) => {
    setSelectedPost(post);
    setIsPreviewOpen(true);
  };

  const closePreview = () => {
    setSelectedPost(null);
    setIsPreviewOpen(false);
  };

  if (isTrackingInProgress) return <NoPostAvailable />;

  if (!content?.posts.length) return <NoContent />;

  return (
    <div className="sl-content-list-section-container">
      <GetSocialListeningModal currentOpenModal={getAddOnModalOpen} setCurrentModal={setGetAddOnModalOpen} />
      <GeneralTable className="sl-content-list-table">
        <thead>
          <tr
            style={{
              ...tableHeadStyle,
              boxShadow: '0px 9px 10px 0px rgba(0, 0, 0, 0.05)',
              zIndex: 10,
            }}>
            {SOCIAL_LISTEING_TABLE_HEADERS.map((head) => (
              <GeneralTableHead style={{ textAlign: head?.align, borderRadius: 0 }} key={head.text}>
                {head.text}
              </GeneralTableHead>
            ))}
          </tr>
        </thead>
        <tbody>
          {content?.posts.map((row, index) => (
            <ContentListTableItem
              row={row}
              key={row._id}
              index={index}
              openPostPreview={() => openPreview(row)}
              onGetAddOnClicked={() => setGetAddOnModalOpen(1)}
            />
          ))}
        </tbody>
      </GeneralTable>
      {isNextContent.totalPages > 1 && (
        <div className="sl-table-pagination-container">
          <PaginationComponent
            totalPages={isNextContent.totalPages}
            currentPage={contentCurrentPage}
            setCurrentPage={(page) => onPageChange(page)}
            style={{ placeItems: 'flex-end' }}
          />
        </div>
      )}
      {selectedPost && <ContentPreviewModal show={isPreviewOpen} onClose={closePreview} post={selectedPost} />}
    </div>
  );
};

export default ContentListSection;
